/* src/app/features/prestacao-informacoes/atualizacao-informacoes-risco/atualizacao-info-risco-cadastro/atualizacao-info-risco-cadastro.component.scss */
.tabela-atualizacao-info-risco {
  margin-top: 15px;
}
/*# sourceMappingURL=atualizacao-info-risco-cadastro.component.css.map */
